<section
    class="tw-bg-[#F8F9FE] tw-py-10 tw-px-[25px] md:tw-px-[30px] xl:tw-px-0"
>
    <div class="tw-max-w-[1280px] tw-mx-auto">
        <!-- Heading -->
        <h2
            class="!tw-text-[22px] md:!tw-text-[28px] tw-text-[#0F3172] !tw-font-bold"
        >
            {{ "INSURANCE_PAGE.POLICY_STREET.APPLY_NOW_FOR" | translate }}
            <br class="sm:tw-hidden" />
            {{ "INSURANCE_PAGE.POLICY_STREET.EMP_BENEFITS" | translate }}
        </h2>
        <p
            class="!tw-text-[#1A202C] !tw-text-[13px] md:!tw-text-[14px] !tw-mb-[30px]"
        >
            {{ "INSURANCE_PAGE.POLICY_STREET.ONE_MORE_STEP" | translate }}
            <br class="sm:tw-hidden" />
            {{ "INSURANCE_PAGE.POLICY_STREET.CONTACT_NOW" | translate }}
        </p>

        <!-- Form -->
        <form
            class="tw-py-6 md:tw-py-8"
            [formGroup]="form"
            (ngSubmit)="submitForm()"
            #formContainer
        >
            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">
                <!-- Full Name -->
                <div>
                    <label
                        class="tw-block tw-text-sm tw-font-medium tw-text-[#7B7575] tw-mb-2"
                        >{{ "FORM.FULL_NAME" | translate
                        }}<span class="tw-text-red-500">*</span></label
                    >
                    <input
                        type="text"
                        class="tw-w-full tw-h-[64px] tw-border tw-border-[#E2E8F0] tw-rounded-xl tw-py-2 tw-px-3 tw-text-sm focus:tw-border-[#0F3172] focus:tw-ring-1 focus:tw-ring-[#0F3172] outline-none"
                        formControlName="name"
                    />
                    <!-- Validation errors (full name) -->
                    <div
                        class="error tw-flex tw-items-center tw-mt-1"
                        *ngIf="
                            form.get('name')?.touched &&
                            form.get('name')?.invalid
                        "
                    >
                        <mat-icon
                            fontSet="material-icons-outlined"
                            class="tw-text-red-500 tw-text-sm error-icon"
                            >info</mat-icon
                        >
                        <span
                            *ngIf="form.get('name')?.errors?.['required']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.FULL_NAME_REQUIRED"
                                    | translate
                            }}
                        </span>
                        <span
                            *ngIf="form.get('name')?.errors?.['pattern'] || form.get('name')?.errors?.['maxlength']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.FULL_NAME_PATTERN"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>

                <!-- Contact Number -->
                <div>
                    <label
                        class="tw-block tw-text-sm tw-font-medium tw-text-[#7B7575] tw-mb-2"
                    >
                        {{
                            "INSURANCE_PAGE.POLICY_STREET.CONTACT_NUMBER"
                                | translate
                        }}<span class="tw-text-red-500">*</span>
                    </label>

                    <div>
                        <!-- Country Code -->

                        <div
                            class="tw-flex tw-rounded-xl tw-overflow-hidden tw-border tw-border-[#E2E8F0] focus-within:tw-border-[#0F3172] focus-within:tw-ring-1 focus-within:tw-ring-[#0F3172]"
                        >
                            <!-- Prefix (+60) -->
                            <div
                                class="tw-flex tw-items-center tw-justify-center tw-w-[63px] tw-h-[64px] tw-bg-white tw-border-r tw-border-[#E2E8F0]"
                            >
                                <span class="tw-text-sm tw-text-[#9A9A9A]"
                                    >+60</span
                                >
                            </div>

                            <!-- Input -->
                            <input
                                type="text"
                                class="tw-flex-1 tw-h-[64px] tw-border-0 tw-px-3 tw-text-sm focus:tw-ring-0 focus:tw-border-0"
                                formControlName="phoneNumber"
                                (keydown)="allowOnlyDigits($event)"
                            />
                        </div>
                    </div>

                    <!-- Validation Errors (now below input, not inline) -->
                    <div
                        class="error tw-flex tw-items-center tw-mt-1"
                        *ngIf="
                            form.get('phoneNumber')?.touched &&
                            form.get('phoneNumber')?.invalid
                        "
                    >
                        <mat-icon
                            fontSet="material-icons-outlined"
                            class="tw-text-red-500 tw-text-sm error-icon"
                            >info</mat-icon
                        >
                        <span
                            *ngIf="form.get('phoneNumber')?.errors?.['required']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.CONTACT_NUMBER_REQUIRED"
                                    | translate
                            }}
                        </span>
                        <span
                            *ngIf="form.get('phoneNumber')?.errors?.['minlength'] || form.get('phoneNumber')?.errors?.['maxlength']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.CONTACT_NUMBER_PATTERN"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>

                <!-- Email Address -->
                <div>
                    <label
                        class="tw-block tw-text-sm tw-font-medium tw-text-[#7B7575] tw-mb-2"
                        >{{
                            "INSURANCE_PAGE.POLICY_STREET.EMAIL_ADDRESS"
                                | translate
                        }}<span class="tw-text-red-500">*</span></label
                    >
                    <input
                        type="email"
                        class="tw-w-full tw-h-[64px] tw-border tw-border-[#E2E8F0] tw-rounded-xl tw-py-2 tw-px-3 tw-text-sm focus:tw-border-[#0F3172] focus:tw-ring-1 focus:tw-ring-[#0F3172] outline-none"
                        formControlName="email"
                    />
                    <!-- Validation Errors(email) -->
                    <div
                        class="error tw-flex tw-items-center tw-mt-1"
                        *ngIf="
                            form.get('email')?.touched &&
                            form.get('email')?.invalid
                        "
                    >
                        <mat-icon
                            fontSet="material-icons-outlined"
                            class="tw-text-red-500 tw-text-sm error-icon"
                            >info</mat-icon
                        >
                        <span
                            *ngIf="form.get('email')?.errors?.['required']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.EMAIL_ADDRESS_REQUIRED"
                                    | translate
                            }}
                        </span>
                        <span
                            *ngIf="form.get('email')?.errors?.['email'] || form.get('email')?.errors?.['invalidEmail'] || form.get('email')?.errors?.['maxlength']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.EMAIL_ADDRESS_PATTERN"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>

                <!-- Company Name -->
                <div>
                    <label
                        class="tw-block tw-text-sm tw-font-medium tw-text-[#7B7575] tw-mb-2"
                        >{{
                            "INSURANCE_PAGE.POLICY_STREET.COMPANY_NAME"
                                | translate
                        }}<span class="tw-text-red-500">*</span></label
                    >
                    <input
                        type="text"
                        class="tw-w-full tw-h-[64px] tw-border tw-border-[#E2E8F0] tw-rounded-xl tw-py-2 tw-px-3 tw-text-sm focus:tw-border-[#0F3172] focus:tw-ring-1 focus:tw-ring-[#0F3172] outline-none"
                        formControlName="companyName"
                    />
                    <!-- Validation Errors(company name) -->
                    <div
                        class="error tw-flex tw-items-center tw-mt-1"
                        *ngIf="
                            form.get('companyName')?.touched &&
                            form.get('companyName')?.invalid
                        "
                    >
                        <mat-icon
                            fontSet="material-icons-outlined"
                            class="tw-text-red-500 tw-text-sm error-icon"
                            >info</mat-icon
                        >
                        <span
                            *ngIf="form.get('companyName')?.errors?.['required']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.COMPANY_NAME_REQUIRED"
                                    | translate
                            }}
                        </span>
                        <span
                            *ngIf="form.get('companyName')?.errors?.['pattern'] || form.get('companyName')?.errors?.['maxlength']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.COMPANY_NAME_PATTERN"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>

                <!-- Business Reg No -->
                <div>
                    <label
                        class="tw-block tw-text-sm tw-font-medium tw-text-[#7B7575] tw-mb-2"
                        >{{
                            "INSURANCE_PAGE.POLICY_STREET.BUSINESS_REG_NO"
                                | translate
                        }}</label
                    >
                    <input
                        type="text"
                        class="tw-w-full tw-h-[64px] tw-border tw-border-[#E2E8F0] tw-rounded-xl tw-py-2 tw-px-3 tw-text-sm focus:tw-border-[#0F3172] focus:tw-ring-1 focus:tw-ring-[#0F3172] outline-none"
                        formControlName="businessRegistrationNumber"
                    />
                    <!-- Validation Errors(company name) -->
                    <div
                        class="error tw-flex tw-items-center tw-mt-1"
                        *ngIf="
                            form.get('businessRegistrationNumber')?.touched &&
                            form.get('businessRegistrationNumber')?.invalid
                        "
                    >
                        <mat-icon
                            fontSet="material-icons-outlined"
                            class="tw-text-red-500 tw-text-sm error-icon"
                            >info</mat-icon
                        >
                        <span
                            *ngIf="form.get('businessRegistrationNumber')?.errors?.['pattern'] || form.get('businessRegistrationNumber')?.errors?.['minlength'] || form.get('businessRegistrationNumber')?.errors?.['maxlength']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.BUSINESS_REG_NO_PATTERN"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>

                <!-- No. of Employees -->
                <div>
                    <label
                        class="tw-block tw-text-sm tw-font-medium tw-text-[#7B7575] tw-mb-2"
                        >{{
                            "INSURANCE_PAGE.POLICY_STREET.NO_OF_EMPLOYEES"
                                | translate
                        }}<span class="tw-text-red-500">*</span></label
                    >
                    <input
                        type="number"
                        min="1"
                        (keydown)="preventNegative($event)"
                        (paste)="preventNegativeOnPaste($event)"
                        class="tw-w-full tw-h-[64px] tw-border tw-border-[#E2E8F0] tw-rounded-xl tw-py-2 tw-px-3 tw-text-sm focus:tw-border-[#0F3172] focus:tw-ring-1 focus:tw-ring-[#0F3172] outline-none"
                        formControlName="noOfEmployees"
                    />
                    <!-- Validation Errors(no of employee) -->
                    <div
                        class="error tw-flex tw-items-center tw-mt-1"
                        *ngIf="
                            form.get('noOfEmployees')?.touched &&
                            form.get('noOfEmployees')?.invalid
                        "
                    >
                        <mat-icon
                            fontSet="material-icons-outlined"
                            class="tw-text-red-500 tw-text-sm error-icon"
                            >info</mat-icon
                        >
                        <span
                            *ngIf="form.get('noOfEmployees')?.errors?.['required']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.NO_OF_EMPLOYEES_REQUIRED"
                                    | translate
                            }}
                        </span>
                        <span
                            *ngIf="form.get('noOfEmployees')?.errors?.['min'] || form.get('noOfEmployees')?.errors?.['max']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.NO_OF_EMPLOYEES_PATTERN"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>

                <!-- Company Address -->
                <div>
                    <label
                        class="tw-block tw-text-sm tw-font-medium tw-text-[#7B7575] tw-mb-2"
                        >{{
                            "INSURANCE_PAGE.POLICY_STREET.COMPANY_ADDRESS"
                                | translate
                        }}<span class="tw-text-red-500">*</span></label
                    >
                    <textarea
                        type="text"
                        class="tw-w-full tw-h-[115px] tw-border tw-border-[#E2E8F0] tw-rounded-xl tw-py-2 tw-px-3 tw-text-sm focus:tw-border-[#0F3172] focus:tw-ring-1 focus:tw-ring-[#0F3172] outline-none"
                        formControlName="companyAddress"
                    >
                    </textarea>
                    <!-- Validation Errors(companyAddress) -->
                    <div
                        class="error tw-flex tw-items-center tw-mt-1"
                        *ngIf="
                            form.get('companyAddress')?.touched &&
                            form.get('companyAddress')?.invalid
                        "
                    >
                        <mat-icon
                            fontSet="material-icons-outlined"
                            class="tw-text-red-500 tw-text-sm error-icon"
                            >info</mat-icon
                        >
                        <span
                            *ngIf="form.get('companyAddress')?.errors?.['required']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.COMPANY_ADDRESS_REQUIRED"
                                    | translate
                            }}
                        </span>
                        <span
                            *ngIf="form.get('companyAddress')?.errors?.['pattern'] || form.get('companyAddress')?.errors?.['maxlength']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.COMPANY_ADDRESS_PATTERN"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>

                <!-- Address of Coverage Location -->
                <div>
                    <label
                        class="tw-block tw-text-sm tw-font-medium tw-text-[#7B7575] tw-mb-2"
                        >{{
                            "INSURANCE_PAGE.POLICY_STREET.COVERAGE_LOCATION"
                                | translate
                        }}<span class="tw-text-red-500">*</span></label
                    >
                    <textarea
                        type="text"
                        class="tw-w-full tw-h-[115px] tw-border tw-border-[#E2E8F0] tw-rounded-xl tw-py-2 tw-px-3 tw-text-sm focus:tw-border-[#0F3172] focus:tw-ring-1 focus:tw-ring-[#0F3172] outline-none"
                        formControlName="coverageLocation"
                    >
                    </textarea>
                    <!-- Validation Errors(coverageLocation) -->
                    <div
                        class="error tw-flex tw-items-center tw-mt-1"
                        *ngIf="
                            form.get('coverageLocation')?.touched &&
                            form.get('coverageLocation')?.invalid
                        "
                    >
                        <mat-icon
                            fontSet="material-icons-outlined"
                            class="tw-text-red-500 tw-text-sm error-icon"
                            >info</mat-icon
                        >
                        <span
                            *ngIf="form.get('coverageLocation')?.errors?.['required']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.COVERAGE_LOCATION_REQUIRED"
                                    | translate
                            }}
                        </span>
                        <span
                            *ngIf="form.get('coverageLocation')?.errors?.['pattern'] || form.get('coverageLocation')?.errors?.['minlength'] || form.get('coverageLocation')?.errors?.['maxlength']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.COVERAGE_LOCATION_PATTERN"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>
            </div>

            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-6">
                <!-- Existing Benefits(mobile) -->
                <div class="tw-block md:tw-hidden tw-mt-6">
                    <label
                        class="tw-block tw-text-sm tw-font-medium tw-text-[#7B7575] tw-mb-2"
                    >
                        {{
                            "INSURANCE_PAGE.POLICY_STREET.EMPLOYEE_BENEFITS_PLAN"
                                | translate
                        }}<span class="tw-text-red-500">*</span>
                    </label>

                    <!-- Radio Buttons -->
                    <div class="tw-flex tw-space-x-6">
                        <label
                            class="tw-inline-flex tw-items-center tw-space-x-2"
                        >
                            <input
                                type="radio"
                                class="tw-h-[18px] tw-w-[18px] tw-text-[#0F3172]"
                                formControlName="employeeBenefitsPlan"
                                value="yes"
                            />
                            <span
                                class="!tw-font-semibold !tw-text-[16px] !tw-text-black"
                            >
                                {{ "COMMON.YES" | translate }}</span
                            >
                        </label>

                        <label
                            class="tw-inline-flex tw-items-center tw-space-x-2"
                        >
                            <input
                                type="radio"
                                class="tw-h-[18px] tw-w-[18px] tw-text-[#0F3172]"
                                formControlName="employeeBenefitsPlan"
                                value="no"
                            />
                            <span
                                class="!tw-font-semibold !tw-text-[16px] !tw-text-black"
                            >
                                {{ "COMMON.NO" | translate }}</span
                            >
                        </label>
                    </div>

                    <!-- Validation Errors (employee benefits) -->
                    <div
                        class="error tw-flex tw-items-center tw-mt-1"
                        *ngIf="
                            form.get('employeeBenefitsPlan')?.touched &&
                            form.get('employeeBenefitsPlan')?.invalid
                        "
                    >
                        <mat-icon
                            fontSet="material-icons-outlined"
                            class="tw-text-red-500 tw-text-sm"
                            >info</mat-icon
                        >
                        <span
                            *ngIf="form.get('employeeBenefitsPlan')?.errors?.['required']"
                            class="tw-text-red-500 tw-text-xs"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.ERROR.EMPLOYEE_BENEFITS_PLAN"
                                    | translate
                            }}
                        </span>
                    </div>
                </div>
                <!-- Comment -->
                <div class="md:tw-mt-6 tw-flex-1">
                    <label
                        class="tw-block tw-text-sm tw-font-medium tw-text-[#7B7575] tw-mb-2"
                        >{{
                            "INSURANCE_PAGE.POLICY_STREET.HELP" | translate
                        }}</label
                    >
                    <textarea
                        rows="3"
                        class="tw-w-full tw-h-[146px] tw-border tw-border-[#E2E8F0] tw-rounded-xl tw-py-2 tw-px-3 tw-text-sm focus:tw-border-[#0F3172] focus:tw-ring-1 focus:tw-ring-[#0F3172] outline-none"
                        formControlName="comment"
                        maxlength="1000"
                    >
                    </textarea>
                    <!-- Validation Errors(help) -->
                    <!-- <div class="error tw-flex tw-items-center tw-mt-1"
      *ngIf="form.get('help')?.touched && form.get('help')?.invalid">
      <mat-icon fontSet="material-icons-outlined" class="tw-text-red-500 tw-text-sm error-icon">info</mat-icon>
      <span *ngIf="form.get('help')?.errors?.['pattern'] || form.get('help')?.errors?.['maxlength']" class="tw-text-red-500 tw-text-xs">
        {{"INSURANCE_PAGE.POLICY_STREET.ERROR.HELP_PATTERN" | translate}}
      </span>
    </div> -->
                </div>

                <div class="tw-flex tw-flex-1 tw-flex-col tw-justify-between">
                    <!-- Existing Benefits(desktop/tablet) -->
                    <div class="tw-hidden md:tw-block tw-mt-6">
                        <label
                            class="tw-block tw-text-sm tw-font-medium tw-text-[#7B7575] tw-mb-2"
                        >
                            {{
                                "INSURANCE_PAGE.POLICY_STREET.EMPLOYEE_BENEFITS_PLAN"
                                    | translate
                            }}<span class="tw-text-red-500">*</span>
                        </label>

                        <!-- Radio Buttons -->
                        <div class="tw-flex tw-space-x-6">
                            <label
                                class="tw-inline-flex tw-items-center tw-space-x-2"
                            >
                                <input
                                    type="radio"
                                    class="tw-h-[18px] tw-w-[18px] tw-text-[#0F3172]"
                                    formControlName="employeeBenefitsPlan"
                                    value="yes"
                                />
                                <span
                                    class="!tw-font-semibold !tw-text-[16px] !tw-text-black"
                                >
                                    {{ "COMMON.YES" | translate }}</span
                                >
                            </label>

                            <label
                                class="tw-inline-flex tw-items-center tw-space-x-2"
                            >
                                <input
                                    type="radio"
                                    class="tw-h-[18px] tw-w-[18px] tw-text-[#0F3172]"
                                    formControlName="employeeBenefitsPlan"
                                    value="no"
                                />
                                <span
                                    class="!tw-font-semibold !tw-text-[16px] !tw-text-black"
                                >
                                    {{ "COMMON.NO" | translate }}</span
                                >
                            </label>
                        </div>

                        <!-- Validation Errors (employee benefits) -->
                        <div
                            class="error tw-flex tw-items-center tw-mt-1"
                            *ngIf="
                                form.get('employeeBenefitsPlan')?.touched &&
                                form.get('employeeBenefitsPlan')?.invalid
                            "
                        >
                            <mat-icon
                                fontSet="material-icons-outlined"
                                class="tw-text-red-500 tw-text-sm"
                                >info</mat-icon
                            >
                            <span
                                *ngIf="form.get('employeeBenefitsPlan')?.errors?.['required']"
                                class="tw-text-red-500 tw-text-xs"
                            >
                                {{
                                    "INSURANCE_PAGE.POLICY_STREET.ERROR.EMPLOYEE_BENEFITS_PLAN"
                                        | translate
                                }}
                            </span>
                        </div>
                    </div>

                    <!-- Checkbox -->
                    <div class="md:tw-mt-[36px] tw-mb-[10px]">
                        <div class="tw-flex tw-items-start tw-gap-2">
                            <input
                                type="checkbox"
                                class="tw-mt-1 tw-text-[#0F3172] tw-border-[#E2E8F0] focus:tw-ring-[#0F3172]"
                                formControlName="termsConditions"
                            />
                            <p class="tw-ml-2 tw-text-xs tw-text-[#4A5568]">
                                {{
                                    "INSURANCE_PAGE.POLICY_STREET.PRIVACY_NOTICE_CONSENT"
                                        | translate
                                }}
                                <a
                                    [href]="
                                        selectedLanguage === 'BM'
                                            ? '/assets/documents/Polisi Privasi(BM).pdf'
                                            : '/assets/documents/Privacy & Security Policies.pdf'
                                    "
                                    target="_blank"
                                    class="tw-text-[#05508A] tw-underline tw-underline-offset-2 tw-decoration-[#05508A]"
                                >
                                    {{ "COMMON.PRIVACY_NOTICE" | translate }}</a
                                >.
                            </p>
                        </div>

                        <!-- Validation Errors (termsConditions) -->
                        <div
                            class="error tw-flex tw-items-center tw-gap-1"
                            *ngIf="
                                form.get('termsConditions')?.touched &&
                                form.get('termsConditions')?.invalid
                            "
                        >
                            <mat-icon
                                fontSet="material-icons-outlined"
                                class="tw-text-red-500 tw-text-sm error-icon"
                            >
                                info
                            </mat-icon>
                            <span
                                *ngIf="form.get('termsConditions')?.errors?.['required']"
                                class="tw-text-red-500 tw-text-xs"
                            >
                                {{
                                    "INSURANCE_PAGE.POLICY_STREET.ERROR.TERMS_CONDITIONS_REQUIRED"
                                        | translate
                                }}
                            </span>
                        </div>
                    </div>

                    <!-- Submit Button -->
                    <div class="tw-flex tw-justify-center md:tw-justify-start">
                        <button
                            type="submit"
                            class="tw-w-[162px] md:tw-w-[171px] tw-h-[43px] md:tw-h-[46px] tw-bg-[#4B6EEC] tw-text-white tw-font-bold tw-text-sm tw-px-6 tw-py-2 tw-rounded-full"
                        >
                            {{ "COMMON.SUBMIT" | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</section>
